var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#128B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.5C19.933 21.5 21.5 19.933 21.5 18C21.5 16.067 19.933 14.5 18 14.5C16.067 14.5 14.5 16.067 14.5 18C14.5 19.933 16.067 21.5 18 21.5ZM18.5 16.5V17.5H19.5C19.7761 17.5 20 17.7239 20 18C20 18.2761 19.7761 18.5 19.5 18.5H18.5V19.5C18.5 19.7761 18.2761 20 18 20C17.7239 20 17.5 19.7761 17.5 19.5V18.5H16.5C16.2239 18.5 16 18.2761 16 18C16 17.7239 16.2239 17.5 16.5 17.5H17.5V16.5C17.5 16.2239 17.7239 16 18 16C18.2761 16 18.5 16.2239 18.5 16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5C16.5 12.1569 15.1569 13.5 13.5 13.5C11.8431 13.5 10.5 12.1569 10.5 10.5C10.5 8.84315 11.8431 7.5 13.5 7.5C15.1569 7.5 16.5 8.84315 16.5 10.5ZM13.5 12.5C14.6046 12.5 15.5 11.6046 15.5 10.5C15.5 9.39543 14.6046 8.5 13.5 8.5C12.3954 8.5 11.5 9.39543 11.5 10.5C11.5 11.6046 12.3954 12.5 13.5 12.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7561 19.5C13.6431 19.1805 13.5653 18.8445 13.5271 18.4965H8.5C8.50142 18.2497 8.65375 17.5104 9.3321 16.8321C9.98435 16.1798 11.2109 15.5 13.5 15.5C13.7605 15.5 14.0072 15.5088 14.2409 15.5254C14.4661 15.184 14.7365 14.8752 15.0436 14.6073C14.5771 14.5382 14.064 14.5 13.5 14.5C8.5 14.5 7.5 17.5 7.5 18.5C7.5 19.5 8.5 19.5 8.5 19.5H13.7561Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/AddPerson.a27fab6616e576bed03f78b335af7347.svg";
export { ForwardRef as ReactComponent };